<template id="TirarSelfie">
    <v-ons-page id="TirarSelfiePage">
        <img src="../assets/img/logo.png" width="200px" style="margin:20px;">
        <h3 class="textoCPF book">Posicione-se e<br> tire uma selfie.</h3>

        <section id="container"> 
          <video ref="video" poster="../assets/img/no-camera.png" id="video" playsinline autoplay></video><br>
          <canvas ref="canvas"  id="canvas" style="display:none"  ></canvas>

        </section>
        <v-ons-bottom-toolbar style="display:flex; align-itens:center; height: 85px">
        <v-ons-row style="align-itens:center; display:flex">
            <v-ons-col>
            <v-ons-button :disabled="!viewing" modifier="transparent"   class="botao" @click="takePicture()">Capturar Selfie</v-ons-button>
            </v-ons-col>
        </v-ons-row> 
        </v-ons-bottom-toolbar>
        <!-- <section>
          <img src="../assets/img/hnk.png" width="200px" style="margin:20px; padding-top:20px">
        </section> -->
    </v-ons-page>
</template>
<style scoped>
#container {
    display: flex;
}
video { 
  max-height:75vh;
  max-width:85vw;
  margin:auto;
  transform: rotateY(180deg);
  -webkit-transform:rotateY(180deg); /* Safari and Chrome */
  -moz-transform:rotateY(180deg); 
}
video::-webkit-media-controls-overlay-play-button {
  display: none;
} 

</style>
<script>
import DirecionamentoVendingVue from './DirecionamentoVending.vue';
export default {
  name: 'TirarSelfie',
  key: 'TirarSelfie',
  props: ['pageStack'],
  data() { 
    return { 
               //vars to handle page status 
            idUser:0,
            dsNome:"",
            text:"Posicione seu rosto",
            viewing:false,
            timer: 3,
            timerStatus:false,
            showLoading: false,
            //Var to handle the context of canvas             
            provider: {
                context: null
            },
            //Vars used for face detection
            tdepth: 0,
            ntrees: 0,
            tcodes : [],
            tpreds : [],
            thresh : [],
            video: "",
            n:0,
            memory:[],
            r:0, 
            c:0,
            s:0,
            pixels:[],
            ldim:0,
            buf:''
        }
    },
    methods: { 
        unpack_cascade: function(bytes) { 
            //
            var dview = new DataView(new ArrayBuffer(4));
            /*
                we skip the first 8 bytes of the cascade file
                (cascade version number and some data used during the learning process)
            */
            var p = 8;
            /*
                read the depth (size) of each tree first: a 32-bit signed integer
            */
            dview.setUint8(0, bytes[p+0]), dview.setUint8(1, bytes[p+1]), dview.setUint8(2, bytes[p+2]), dview.setUint8(3, bytes[p+3]);
            this.tdepth = dview.getInt32(0, true);
            p = p + 4
            /*
                next, read the number of trees in the cascade: another 32-bit signed integer
            */
            dview.setUint8(0, bytes[p+0]), dview.setUint8(1, bytes[p+1]), dview.setUint8(2, bytes[p+2]), dview.setUint8(3, bytes[p+3]);
            this.ntrees = dview.getInt32(0, true);
            p = p + 4
            /*
                read the actual trees and cascade this.thresholds
            */


            for(var t=0; t<this.ntrees; ++t)
            {
                var i;
                // read the binary tests placed in internal tree nodes
                Array.prototype.push.apply(this.tcodes, [0, 0, 0, 0]);
                Array.prototype.push.apply(this.tcodes, bytes.slice(p, p+4*Math.pow(2, this.tdepth)-4));
                p = p + 4*Math.pow(2, this.tdepth)-4;
                // read the prediction in the leaf nodes of the tree
                for(i=0; i<Math.pow(2, this.tdepth); ++i)
                {
                    dview.setUint8(0, bytes[p+0]), dview.setUint8(1, bytes[p+1]), dview.setUint8(2, bytes[p+2]), dview.setUint8(3, bytes[p+3]);
                    this.tpreds.push(dview.getFloat32(0, true));
                    p = p + 4;
                }
                // read the threshold
                dview.setUint8(0, bytes[p+0]), dview.setUint8(1, bytes[p+1]), dview.setUint8(2, bytes[p+2]), dview.setUint8(3, bytes[p+3]);
                this.thresh.push(dview.getFloat32(0, true));
                p = p + 4;
            }
            this.tcodes = new Int8Array(this.tcodes)
            this.tpreds = new Float32Array(this.tpreds)
            this.thresh = new Float32Array(this.thresh)
            /*
                we're done
            */
        
            return this.classify_region();
        },
        classify_region :function(r, c, s, pixels, ldim) {    

                r = (isNaN(r)) ? 256 : 256*r;
                c = (isNaN(c)) ? 256 : 256*c;
                var root = 0;
                var o = 0.0;
                var pow2tdepth = Math.pow(2, this.tdepth) >> 0; // '>>0' transforms this number to int
                if (pixels != undefined) { 
                for(var i=0; i<this.ntrees; ++i)
                {
                var idx = 1;
                for(var j=0; j<this.tdepth; ++j)
                    // we use '>> 8' here to perform an integer division: this seems important for performance
                    idx = 2*idx + (pixels[((r+this.tcodes[root + 4*idx + 0]*s) >> 8)*ldim+((c+this.tcodes[root + 4*idx + 1]*s) >> 8)]<=pixels[((r+this.tcodes[root + 4*idx + 2]*s) >> 8)*ldim+((c+this.tcodes[root + 4*idx + 3]*s) >> 8)]);
                    o = o + this.tpreds[pow2tdepth*i + idx-pow2tdepth];

                    if(o<=this.thresh[i])
                        return -1;

                    root += 4*pow2tdepth;
                }
                }
                return o - this.thresh[this.ntrees-1];
        },
        run_cascade: function(image, classify_region, params) {
            var pixels = image.pixels;
            var nrows = image.nrows;
            var ncols = image.ncols;
            var ldim = image.ldim;

            var shiftfactor = params.shiftfactor;
            var minsize = params.minsize;
            var maxsize = params.maxsize;
            var scalefactor = params.scalefactor;

            var scale = minsize;
            var detections = [];

            while(scale<=maxsize)
            {
                var step = Math.max(shiftfactor*scale, 1) >> 0; // '>>0' transforms this number to int
                var offset = (scale/2 + 1) >> 0;

                for(var r=offset; r<=nrows-offset; r+=step)
                    for(var c=offset; c<=ncols-offset; c+=step)
                    {
                        var q = this.classify_region(r, c, scale, pixels, ldim);
                        if (q > 0.0)
                            detections.push([r, c, scale, q]);
                    }
                
                scale = scale*scalefactor;
            }

            return detections;
        },
        cluster_detections: function(dets, iouthreshold) {
            /*
                sort detections by their score
            */
            dets = dets.sort(function(a, b) {
                return b[3] - a[3];
            })
            /*
                this helper function calculates the intersection over union for two detections
            */
            function calculate_iou(det1, det2)
            {
                // unpack the position and size of each detection
                var r1=det1[0], c1=det1[1], s1=det1[2];
                var r2=det2[0], c2=det2[1], s2=det2[2];
                // calculate detection overlap in each dimension
                var overr = Math.max(0, Math.min(r1+s1/2, r2+s2/2) - Math.max(r1-s1/2, r2-s2/2));
                var overc = Math.max(0, Math.min(c1+s1/2, c2+s2/2) - Math.max(c1-s1/2, c2-s2/2));
                // calculate and return IoU
                return overr*overc/(s1*s1+s2*s2-overr*overc);
            }
            /*
                do clustering through non-maximum suppression
            */
            var assignments = new Array(dets.length).fill(0);
            var clusters = [];
            for(var i=0; i<dets.length; ++i)
            {
                // is this detection assigned to a cluster?
                if(assignments[i]==0)
                {
                    // it is not:
                    // now we make a cluster out of it and see whether some other detections belong to it
                    var r=0.0, c=0.0, s=0.0, q=0.0, n=0;
                    for(var j=i; j<dets.length; ++j)
                        if(calculate_iou(dets[i], dets[j])>iouthreshold)
                        {
                            assignments[j] = 1;
                            r = r + dets[j][0];
                            c = c + dets[j][1];
                            s = s + dets[j][2];
                            q = q + dets[j][3];
                            n = n + 1;
                        }
                    // make a cluster representative
                    clusters.push([r/n, c/n, s/n, q]);
                }
            }

            return clusters;
        },
        update_memory: function(dets) {
            this.memory[this.n] = dets;
            this.n = (this.n+1)%this.memory.length;
            dets = [];
            for( var i=0; i<this.memory.length; ++i)
                dets = dets.concat(this.memory[i]);
                //
                return dets;
        },
        instantiate_detection_memory: function(size){
            /*
                initialize a circular buffer of `size` elements
            */
            this.n = 0; this.memory = [];
            for(var i=0; i<size; ++i)
                this.memory.push([]);
                
            /*
                build a function that:
                (1) inserts the current frame's detections into the buffer;
                (2) merges all detections from the last `size` frames and returns them
            */
            /*
                we're done
            */
            return this.update_memory;
        },
        rgba_to_grayscale: function(rgba, nrows, ncols) {
            var gray = new Uint8Array(nrows*ncols);
            for(var r=0; r<nrows; ++r)
                for(var c=0; c<ncols; ++c)
                    // gray = 0.2*red + 0.7*green + 0.1*blue
                    gray[r*ncols + c] = (2*rgba[r*4*ncols+4*c+0]+7*rgba[r*4*ncols+4*c+1]+1*rgba[r*4*ncols+4*c+2])/10;
            return gray;
        },
        processfn: function(video) {
            if (video) { 
              var canvas = this.$refs['canvas'];
              canvas.width = video.videoWidth;
              canvas.height = video.videoHeight;
              this.provider.context = canvas.getContext('2d');
              var ctx = this.provider.context;

              // render the video frame to the canvas element and extract RGBA pixel data
              ctx.drawImage(video, 0, 0);
              var rgba = ctx.getImageData(0, 0, 500, 500).data;


              // prepare input to `run_cascade`
              var image = {
                  "pixels": this.rgba_to_grayscale(rgba, 500, 500),
                  "nrows": 500,
                  "ncols": 500,
                  "ldim": 500
              }
              var params = {
                  "shiftfactor": 0.1, // move the detection window by 10% of its size
                  "minsize":50,     // minimum size of a face
                  "maxsize": 1000,    // maximum size of a face
                  "scalefactor": 1.1  // for multiscale processing: resize the detection window by 10% when moving to the higher scale
              }
              // run the cascade over the frame and cluster the obtained detections
              // dets is an array that contains (r, c, s, q) quadruplets
              // (representing row, column, scale and detection score)
              var dets = this.run_cascade(image, this.facefinder_classify_region, params);
              dets = this.update_memory(dets);
              dets = this.cluster_detections(dets, 0.2); // set IoU threshold to 0.2
              // draw detections
              var faceDetected = 0
              for(var i=0; i<dets.length; ++i)
                  // check the detection score
                  // if it's above the threshold, draw it
                  // (the constant 50.0 is empirical: other cascades might require a different one)
                  
                  if((dets[i][3]>50.0))
                  {
                      faceDetected++;
                      // ctx.beginPath();
                      // ctx.arc(dets[i][1], dets[i][0], dets[i][2]/2, 0, 2*Math.PI, false);
                      // ctx.lineWidth = 3;
                      // ctx.strokeStyle = 'blue';
                      // ctx.stroke();
                      //if (!this.timerStatus) { this.timerStatus = true; this.text="Aguarde..."; setTimeout(this.takePicture, 1000) }
                  }
              return faceDetected
            }
            
        },
        takePicture: function() { 
          if (this.processfn(this.video) == 1) { 
            var canvas = this.$refs["canvas"]
            canvas.getContext("2d").drawImage(this.video, 0, 0, canvas.width, canvas.height);
            var selfieBase64 =  canvas.toDataURL("image/png");
            this.takedPhoto = true;
            this.video.pause()
            // this.video.srcObject.getVideoTracks()[0].stop();
            // this.video.style.display= "none";
            // this.video.src = this.video.srcObject = null;
            this.u = { }
            this.u.base64Selfie = selfieBase64.split("data:image/png;base64,")[1]
            this.u.idCliente = localStorage.getItem("idCliente")
            fetch(this.$hnk00_uri +'/cadastrar-selfie',
                { method: "OPTIONS",
                headers:  { "Content-Type": "application/json" },
                body: JSON.stringify(this.u)})
            .then(response => response.json())
            .then(data => { 
                if (data == "True") { 
                    this.video.srcObject.getVideoTracks()[0].stop();
                    this.video.src = this.video.srcObject = null;
                // this.$ons.notification.toast("Cadastro realizado com sucesso, realize o login na proxima pagina! ", { timeout: 1000, animation: 'ascend' });          
                    this.$emit("push", DirecionamentoVendingVue)
                }
                else { 
                    this.$ons.notification.toast("Erro ao realizar cadastro, por favor tente novamente! ", { timeout: 1000, animation: 'ascend' });
                    this.video.play()
                    this.btnDisable = false;
                }
            })
            .catch(error => {
            this.$ons.notification.toast("Erro ao realizar cadastro, por favor tente novamente! ", { timeout: 1000, animation: 'ascend' });
            localStorage.setItem("fetchErr", error);
                        this.video.play()
            this.btnDisable = false;
            });
          }
          else {  
            this.viewing = true 
            this.$ons.notification.toast("Por favor, certifique-se que seu rosto esteja centralizado na camera!", { timeout: 1000, animation: 'ascend' });
          }          
        },
        camvas: function(ctx, callback) {
            var self = this
            this.ctx = ctx
            this.callback = callback

            // The callback happens when we are starting to stream the video.
            navigator.mediaDevices.getUserMedia({video: { facingMode: "user" }, audio: false}).then(function(stream) {
                // Yay, now our webcam input is treated as a normal video and
                // we can start having fun
                self.video.srcObject = stream;

                // Let's start drawing the canvas!
                self.updateWeb();
            }, function(err) {
                throw err
            })

        },
        updateWeb: function() { 
            var self = this
            var loop = function() {
              //  self.processfn(self.video)
                 if (self.viewing) { requestAnimationFrame(loop) }
            }
            requestAnimationFrame(loop) 
        },
        facefinder_classify_region: function(r, c, s, pixels, ldim) {
            this.r = r
            this.c = c 
            this.s = s 
            this.pixels = pixels 
            this.ldim = ldim
            return -1.0;
        },
        start_webcam: function() { 
            //var self = this
            if(this.viewing)
                return; 
            this.instantiate_detection_memory(5);
        
            this.provider.context = this.$refs['canvas'].getContext('2d');
            var ctx = this.provider.context;
            this.video = this.$refs["video"];

            this.mycamvas = this.camvas(ctx, this.processfn());

            this.viewing = true;

        },
        back () { 
          this.$emit('pop');
        }
    },
    created() { 
        var self = this
        var cascadeurl = "https://raw.githubusercontent.com/nenadmarkus/pico/c2e81f9d23cc11d1a612fd21e4f9de0921a5d0d9/rnt/cascades/facefinder"
       // var cascadeurl = '../static/facefinder.class';
        fetch("/light-on").then(response => { response.data }).then(buffer => { this.buf = buffer })

        fetch(cascadeurl)
        .then(response => response.arrayBuffer())
        .then(buffer => {
            var bytes = new Int8Array(buffer);               
            self.facefinder_classify_region = self.unpack_cascade(bytes);
        })
    },
    mounted() { 
        this.start_webcam();
    }
}
</script>